export const cleanData = ({ data, columns }) => {
  const cleanData = [];

  if (!data?.length || !columns) return cleanData;

  data.forEach((row) => {
    const cleanRow = {};

    columns.forEach((column) => {
      if (column.export) cleanRow[column.name] = row[column.name];
    });

    cleanData.push(cleanRow);
  });

  return cleanData;
};
